import MainIcon from "assets/menu-icons/MainIcon";

const main = {
  id: 'mainPage',
  type: 'group',
  children: [
    {
      id: 'main',
      title: 'Главная',
      type: 'item',
      url: '/main',
      icon: MainIcon,
      breadcrumbs: false,
      children: [
        {
          id: 'myCard',
          url: '/main/myCard',
          icon: null,
          breadcrumbs: false,
        }, 
        {
          id: 'clinicAppointment',
          url: '/main/clinicAppointment',
          icon: null,
          breadcrumbs: false,
        }, 
        {
          id: 'contacts',
          url: '/main/contacts',
          icon: null,
          breadcrumbs: false,
        }, 
        {
          id: 'promotions',
          url: '/main/promotions',
          icon: null,
          breadcrumbs: false,
        },
        {
          id: 'chatFeedBack',
          url: '/main/chatFeedBack',
          icon: null,
          breadcrumbs: false,
        },
        {
          id: 'services',
          url: '/main/services',
          icon: null,
          breadcrumbs: false,
        },
        {
          id: 'payment',
          url: '/main/payment',
          icon: null,
          breadcrumbs: false,
        },
        {
          id: 'basket',
          url: '/main/basket',
          icon: null,
          breadcrumbs: false,
        }
      ]
    }
  ]
}

export default main;